import { normalizeAttachments } from '../platform/contentAttachments';

class Document {
    constructor({
      id,
      title,
      description,
      fileUrl,
      attachments,
      uid,
      displayName,
      createdAt,
      unit,
      unitName,
      order,
      tenantId,
    }) {
      this.id = id || null;
      this.title = title || '';
      this.description = description || '';
      this.fileUrl = fileUrl || '';
      this.attachments = normalizeAttachments({ fileUrl, attachments });
      this.uid = uid || '';
      this.displayName = displayName || 'Anonimen';
      this.createdAt = createdAt || new Date();
      this.unit = unit || 'general';
      this.unitName = unitName || 'Splošno';
      this.order = order || 0;
      this.tenantId = tenantId || null;
    }
  
    toFirestore() {
      return {
        title: this.title,
        description: this.description,
        fileUrl: this.attachments[0]?.url || this.fileUrl || '',
        attachments: this.attachments,
        uid: this.uid,
        displayName: this.displayName,
        createdAt: this.createdAt,
        unit: this.unit,
        unitName: this.unitName,
        order: this.order,
      };
    }
  
    static fromFirestore(snapshot) {
      const data = snapshot.data();
      return new Document({
        id: snapshot.id,
        title: data.title,
        description: data.description,
        fileUrl: data.fileUrl,
        attachments: data.attachments,
        uid: data.uid,
        displayName: data.displayName,
        createdAt: data.createdAt ? data.createdAt.toDate() : new Date(),
        unit: data.unit || 'general',
        unitName: data.unitName || 'Splošno',
        order: data.order || 0,
        tenantId: data.tenantId || null,
      });
    }
  }
  
  export default Document;
